import styledComp from 'styled-components';
import {
  FormControl,
  List,
  Checkbox,
} from '@mui/material';
import { Styling, Colors } from '../../../../constants';
import { VaultButton } from '../../../Shared';

const teamImageMaxHeight = 30;
const teamImageMaxWidth = 30;

export const ActionButtonClass = 'TeamSelectionActionButton';

export const Container = styledComp.div`
  align-items: center;
  display: flex;
`;

export const TeamsSelect = styledComp(FormControl)`
  max-width: 500px;
  min-width: 132px !important;
`;

export const ImageContainer = styledComp.div`
  display: flex;
  height: ${teamImageMaxHeight}px;
  justify-content: center;
  margin-right: 8px;
  width: ${teamImageMaxWidth}px;
`;

export const Image = styledComp.img`
  align-self: center;
  max-height: ${teamImageMaxHeight}px;
  max-width: ${teamImageMaxWidth}px;
`;

export const TeamsList = styledComp(List)`
  width: 375px;
  .${ActionButtonClass}.active {
    color: ${Colors.RED_1};
  }
`;

export const TeamCheckbox = styledComp(Checkbox)`
  margin-left: 4px !important;
`;

export const Button = styledComp(VaultButton)`
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const Header = styledComp.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 10px 10px 10px ${Styling.DEFAULT_SPACING}px;
`;
